import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { Filter } from "@sharedV11/classes/filters/filter";
import { clientes_select } from "@sharedV11/classes/tipoCodigoPromociones/clientes_select";
import {
  tipoCodigoPromociones,
  tipoEntradaPlantilla,
  tipoPromoEntradaPlantilla,
} from "@sharedV11/classes/tipoCodigoPromociones/tipoCodigoPromociones";
import { DialogoPopUp } from "@sharedV11/components/alert/dialog/popup.service";
import { TableInteractiveComponent } from "@sharedV11/components/tables/table-interactive/table-interactive.component";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { EditTipoCodigoPromocionesService } from "@sharedV11/services/components/edit-tipo-codigo-promociones/edit-tipo-codigo-promociones.service";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ModalAnadirTodasComponent } from "./modal-anadir-todas.component";

@Component({
  selector: "app-edit-tipo-codigo-promociones",
  templateUrl: "./edit-tipo-codigo-promociones.component.html",
  styleUrls: ["./edit-tipo-codigo-promociones.component.scss"],
})
export class EditTipoCodigoPromocionesComponent implements OnInit {
  loading = true;
  private ngUnsubscribe = new Subject();

  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;

  @ViewChild("ti_tiposEntrada") ti_tiposEntrada: TableInteractiveComponent;
  @ViewChild("ti_tiposPromociones")
  ti_tiposPromociones: TableInteractiveComponent;

  ///clientesASs: any;
  listaClientes = [];
  //////
  tiposEntrada: any;
  translation: any;
  elementosBorrados: string[] = [];
  tiposBonoEntrada: tipoEntradaPlantilla[];
  promocionEntradaFormGroup: FormArray = this.formBuilder.array([]);
  columnsToDisplayTarifaEntrada: string[];

  //editorRegistroForm: FormGroup;
  itemsTipoCodigoPromociones: tipoCodigoPromociones;

  dataSourceTarifaPromocionEntrada: MatTableDataSource<tipoEntradaPlantilla>;
  ///////
  tiposBonoEntrada1: tipoPromoEntradaPlantilla[];
  tiposEntrada1: any;
  elementosBorrados1: string[] = [];
  promocionEntradaFormGroup1: FormArray = this.formBuilder.array([]);
  columnsToDisplayTarifaEntrada1: string[];

  //editorRegistroForm1: FormGroup;

  dataSourceTarifaPromocionEntrada1: MatTableDataSource<tipoEntradaPlantilla>;
  ///////
  editRegistroForm: FormGroup;

  tablavalida = true;
  tablavalida1 = true;

  tipoCodigoPromociones: tipoCodigoPromociones;
  clientesloaded: boolean = false;
  listaCanales: any = [];

  //centros
  centrosSinAsignar = [];
  centrosAsignados = [];
  centrosasociados: string[] = [];
  tipoCentros: any[] = [];
  CentrosAPI: any;
  format: {
    add: any;
    remove: any;
    all: any;
    none: any;
    direction: any;
    draggable: boolean;
    locale: string;
  };

  //codigos
  tieneCodigosAsociados: boolean = false;

  //centros

  // Propriedades para controlar estado dos botões
  entradasAddedIndividually: boolean = false;
  promocionesAddedIndividually: boolean = false;
  entradasAddedAll: boolean = false;
  promocionesAddedAll: boolean = false;
  listaTodasEntradas: any[] = [];
  listaTodasPromociones: any[] = [];

  // Formulário para modal añadir todas
  modalFormAnadirTodas: FormGroup;

  constructor(
    private editTipoCodigoPromocionesService: EditTipoCodigoPromocionesService,
    public servicioAPI: ConectarApiService,
    private fb: FormBuilder,
    private translator: Translator,
    private cdRef: ChangeDetectorRef,
    private panelService: PanelService,
    private snackvar_service: SnackbarInfoService,
    private httpErrorService: HttpErrorsService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog
  ) {}

  getNombreGrupoById(id: string) {
    // TODO: falta acceso a la tabla tbGrupoTipoBono.PkId
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit(): void {
    //this.cargarDatos();

    this.initializeTranslate();
    this.initializeFormWithoutData();
    this.initializeModalForm();
    this.cargarDatos();
    this.getTodasEntradasDisponibles();
    this.getTodasPromocionesDisponibles();
    this.manageForm(this.pkId, this.mode);

    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };

    this.columnsToDisplayTarifaEntrada = [
      "Acciones",
      "NombreTipoEntrada",
      "iNumEntradas",
    ];

    this.columnsToDisplayTarifaEntrada1 = [
      "Acciones",
      "NombreTipoEntrada",
      "iNumEntradas",
    ];
    /*  this.tiposEntrada = {"DatosResult":{"tipoCodigoPromo":[{
      pkId: "1",
            Nombre: "ejemplo",
            chNombre: "ejemplo1",
            chDescripcion: "Descripción...",
            Descripcion: "Descripción...",
            bDeBaja: 0,
            iCodigoCliente: 0
    }]}}; */
  }

  cargarDatos() {
    //Cargamos Datos

    let filters: Filter[] = [];
    this.servicioAPI.traerDatosClientes().subscribe(
      (data) => {
        if (data.DatosListas) {
          if (Array.isArray(data.DatosListas) && data.DatosListas.length > 0) {
          this.listaClientes = data.DatosListas.filter(dato => dato.Nombre !== "");
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.servicioAPI.ObtenerCustomanCanales().then(
      (data) => {
        if (data.DatosResult) {
          this.listaCanales = data.DatosResult?.Lista || [];
          this.listaCanales.forEach((element) => {
            element.canalsubcanal = element.SubCanal;
          });
        } else {
          /* this.snackvar_service.openSnackBar(
            this.translation.NO_DATOS_FILTRO_CANAL || "No hay datos de canal",
            "",
            "red-snackbar"
          ); */
          this.listaCanales = [];
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    //centros en cargar datos
    this.servicioAPI.getCentros().subscribe(
      (data) => {
        this.CentrosAPI = data;
        this.tipoCentros = [];
        if (this.CentrosAPI.DatosResult != null) {
          if (this.CentrosAPI.DatosResult.ListaCentros != null) {
            this.tipoCentros = this.CentrosAPI.DatosResult.ListaCentros;
            this.centrosSinAsignar = this.filtrarTiposCentros();
            this.centrosAsignados = this.daTiposCentros();
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
    
    //Codigos promocionales por tipo de codigo
    if (this.pkId) {
      this.editTipoCodigoPromocionesService
        .getCodigosPromocionalesByTipoId(this.pkId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            const codigosPromocionales = data?.DatosResult?.ListaCodigoPromocional ?? [];
            this.tieneCodigosAsociados = codigosPromocionales.length > 0;
          },
          (error) => {
            this.httpErrorService.identificarErrores(error);
          }
        );
    }
  }

  //centros
  filtrarTiposCentros() {
    // return this.tipoCentros.filter(x => x.Activo == "True");
    let respuesta = [];
    let Centros = this.tipoCentros.filter((x) => x.Activo == "True");
    let tmpCentrosAsociados = this.centrosasociados;
    if (Centros != null && Centros.length > 0) {
      respuesta = Centros.filter(function (item) {
        return (
          tmpCentrosAsociados.findIndex(function (itemSub) {
            return itemSub == item.pkId;
          }) === -1
        );
      });
    } else {
      respuesta = this.tipoCentros.filter((x) => x.Activo == "True");
    }
    return respuesta;
  }

  comparaObjetosSelect(o1: any, o2: any) {
    return o1 && o2
      ? o1.id === o2.id || o1 === o2.id || o1.id === o2
      : o1 === o2;
  }
  asignarTipoCentro(item, evento) {
    this.centrosasociados.push(item.pkId);
  }
  desasignarTipoCentro(item, evento) {
    let arrtemp = [];
    arrtemp = this.centrosasociados.filter(function (x) {
      return x != item.pkId;
    });
    this.centrosasociados = arrtemp;
  }

  deasignarTodosCentros() {
    this.centrosasociados = [];
  }
  asignarTodosCentros() {
    this.centrosasociados = this.tipoCentros
      .filter((x) => x.Activo == "True")
      .map(function (x) {
        return x.pkId;
      });
  }

  obtenercentrosAsociadosconOrden(): string {
    let respuesta: string = "";
    let elemento: string;
    let count = 0;
    if (this.centrosAsignados) {
      this.centrosAsignados.forEach((centro) => {
        //let orden = this.getOrdenRecinto(actividad);
        elemento = centro.pkId + ",";
        // elemento = element + ":" + (this.ordenRecintosAsociados[count] == null ? '0' : this.ordenRecintosAsociados[count]) + ",";
        respuesta = respuesta + elemento;
        count++;
      });
    }
    return respuesta.substring(0, respuesta.length - 1);
  }

  daTiposCentros(): any[] {
    let respuesta = [];
    if (this.tipoCentros != null && this.tipoCodigoPromociones) {
      if (this.tipoCodigoPromociones.CentrosIds) {
        let arrayCentrosString =
          this.tipoCodigoPromociones.CentrosIds.split(",");
        let arrayCentros = [];

        let allCentros = this.tipoCentros.filter((x) => x.Activo == "True");

        let array = arrayCentrosString.map((centropkId) => {
          let act = allCentros.find((find) => find.pkId == centropkId);
          respuesta.push(act);
        });
      }
    }

    return respuesta;
  }
  //centros

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
  }

  initializeFormWithoutData() {
    this.editRegistroForm = this.fb.group({
      pkId: [""],
      Nombre: ["", Validators.required],
      Descripcion: ["", Validators.required],
      CodigoCliente: ["", Validators.required],
      CanalNombre: [""],
      DeBaja: [false, Validators.required],
      CanalId: [""]
    });
  }
  manageForm(pkId, mode) {
    console.log({
      pkId,
      mode,
    })
    if (mode == "I") {
      this.tipoCodigoPromociones = this.editRegistroForm.value;
      this.loading = false;
      this.valuedChanged();
    }
    if (pkId && pkId !== "") {
      console.log('findTipoCodigoPromocional')
      this.findTipoCodigoPromocional(pkId);
    }
  }

  findTipoCodigoPromocional(pkId) {
    this.editTipoCodigoPromocionesService
      .getTiposCodigoPromocionalByPkId(pkId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          // let Categoria:Categoria =  CategoriaApi["DatosResult"]["customanUsuarios"][0];
          let tipocodpromo: tipoCodigoPromociones =
            data["DatosResult"]["ListaCodigoPromocional"][0];
          if (tipocodpromo != null) {
            this.changeValueForm(tipocodpromo);
            
            // Garantir que tipoCodigoPromociones tenha os valores corretos da API
            // especialmente CodigoCliente e CanalId que podem não estar no formulário ainda
            // Converter para string para garantir compatibilidade com input-filter
            const codigoCliente = tipocodpromo.CodigoCliente != null 
              ? String(tipocodpromo.CodigoCliente) 
              : (this.editRegistroForm.value.CodigoCliente ?? '');
            const canalId = tipocodpromo.CanalId != null 
              ? String(tipocodpromo.CanalId) 
              : (this.editRegistroForm.value.CanalId ?? '');
            
            this.tipoCodigoPromociones = {
              ...this.editRegistroForm.value,
              CodigoCliente: codigoCliente,
              CanalId: canalId,
              CentrosIds: tipocodpromo.CentrosIds
            };
            
            this.centrosAsignados = this.daTiposCentros();
            this.valuedChanged();
            this.loading = false;
            
            // Forçar detecção de mudanças para atualizar os componentes input-filter
            this.cdRef.detectChanges();
            
            // Verificar estado inicial dos botones después de cargar datos
            setTimeout(() => {
              this.verificarEstadoBotonesEntradas();
              this.verificarEstadoBotonesPromociones();
            }, 500);
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  changeValueForm(tipoCodigoPromociones: tipoCodigoPromociones) {
    this.editRegistroForm.get("pkId").setValue(tipoCodigoPromociones.pkId);

    this.editRegistroForm
      .get("Nombre")
      .setValue(
        tipoCodigoPromociones.chNombre == undefined
          ? tipoCodigoPromociones.Nombre
          : tipoCodigoPromociones.chNombre
      );
    this.editRegistroForm
      .get("Descripcion")
      .setValue(
        tipoCodigoPromociones.chDescripcion == undefined
          ? tipoCodigoPromociones.Descripcion
          : tipoCodigoPromociones.chDescripcion
      );
    
    // Converter para string para garantir compatibilidade com input-filter
    // IMPORTANTE: Aceitar "0" como valor válido (não tratar como vazio)
    const codigoCliente = tipoCodigoPromociones.CodigoCliente != null && tipoCodigoPromociones.CodigoCliente !== undefined
      ? String(tipoCodigoPromociones.CodigoCliente) 
      : '';
    const canalId = tipoCodigoPromociones.CanalId != null && tipoCodigoPromociones.CanalId !== undefined
      ? String(tipoCodigoPromociones.CanalId) 
      : '';
    
    this.editRegistroForm
      .get("CodigoCliente")
      .setValue(codigoCliente);

    this.editRegistroForm
      .get("DeBaja")
      .setValue(tipoCodigoPromociones.DeBaja == "1" ? true : false);
    
    this.editRegistroForm
      .get("CanalId")
      .setValue(canalId);
    
    // Atualizar tipoCodigoPromociones imediatamente para que os componentes input-filter recebam os valores
    // Usar any para permitir tanto string (para input-filter) quanto number (para a interface)
    if (!this.tipoCodigoPromociones) {
      this.tipoCodigoPromociones = {} as any;
    }
    // Manter como string para o input-filter, mas também preservar o valor numérico quando necessário
    const tipoCodigoPromocionesAny = this.tipoCodigoPromociones as any;
    tipoCodigoPromocionesAny.CodigoCliente = codigoCliente;
    tipoCodigoPromocionesAny.CanalId = canalId;
  }

  valuedChanged() {
    this.editRegistroForm.valueChanges.subscribe((value) => {
      if (this.tipoCodigoPromociones != null) {
        this.panelService.setDiscardChanges(false);
        if (
          JSON.stringify(value) === JSON.stringify(this.tipoCodigoPromociones)
        ) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }
  submit(cerrarpanel: boolean = true) {
    // Verificar estado dos botones antes de submit
    this.verificarEstadoBotonesEntradas();
    this.verificarEstadoBotonesPromociones();
    
    if (
      (this.ti_tiposEntrada && this.ti_tiposEntrada.dataSource && this.ti_tiposEntrada.dataSource.data.length > 0) ||
      (this.ti_tiposPromociones && this.ti_tiposPromociones.dataSource && this.ti_tiposPromociones.dataSource.data.length > 0)
    ) {
      const tiposEntradasData = this.ti_tiposEntrada.dataSource.data;
      const tiposPromocionesData = this.ti_tiposPromociones.dataSource.data;

      const tipoEntradaIdRequired = tiposEntradasData.filter(x => !x.TipoEntradaId || x.TipoEntradaId === "").length > 0;

      const tipoPromocionIdRequired = tiposPromocionesData.filter(x => !x.TipoBonoId || x.TipoBonoId === "").length > 0;

      if (tipoEntradaIdRequired || tipoPromocionIdRequired) {
        this.snackvar_service.openSnackBar(
          this.translation.CAMPOS_INVALIDOS || "No hay entradas ni promociones",
          "",
          "red-snackbar"
        );
        return;
      }

      this.editRegistroForm.markAllAsTouched();
      let tipoCodigoPromociones: tipoCodigoPromociones =
        this.editRegistroForm.value;
      tipoCodigoPromociones["TipoCodigoPromocionalEntradas"] =
        this.ti_tiposEntrada.dataSource.data;
      tipoCodigoPromociones["TipoCodigoPromocionalTiposBono"] =
        this.ti_tiposPromociones.dataSource.data;
      if (this.editRegistroForm.valid) {
        this.manageApi(tipoCodigoPromociones, this.mode, cerrarpanel);
      } else {
        this.snackvar_service.openSnackBar("Faltan datos", "", "red-snackbar");
      }
    } else {
      this.snackvar_service.openSnackBar(
        this.translation.MENSAJE_NO_ENTRADA_PROMOCION || "No hay entradas ni promociones",
        "",
        "red-snackbar"
      );
    }
  }

  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  save(cerrarpanel?) {
    this.loading = false;
    this.panelService.setDiscardChanges(true);

    this.panelService.setSavePanel(cerrarpanel);
  }
  discard() {
    this.changeValueForm(this.tipoCodigoPromociones);
  }
  manageApi(tipoCodigoPromociones: tipoCodigoPromociones, mode, cerrarpanel?) {
    this.loading = true;
    //TipoCodigoPromocionalEntradas
    //TipoCodigoPromocionalTiposBono
    if (tipoCodigoPromociones.TipoCodigoPromocionalEntradas) {
      tipoCodigoPromociones.TipoCodigoPromocionalEntradas.forEach((e) => {
       
        if (e.DeBaja === true || e.DeBaja === "1" || e.DeBaja === 1 || e.DeBaja === "true") {
          e.DeBaja = "1";
        } else {
          e.DeBaja = "0";
        }
        if (e.HeredarDeBajaEnCodigoPromocional === true || e.HeredarDeBajaEnCodigoPromocional === "1" || e.HeredarDeBajaEnCodigoPromocional === 1 || e.HeredarDeBajaEnCodigoPromocional === "true") {
          e.HeredarDeBajaEnCodigoPromocional = "1";
        } else if (e.HeredarDeBajaEnCodigoPromocional === false || e.HeredarDeBajaEnCodigoPromocional === "0" || e.HeredarDeBajaEnCodigoPromocional === 0 || e.HeredarDeBajaEnCodigoPromocional === "false") {
          e.HeredarDeBajaEnCodigoPromocional = "0";
        } else {
          e.HeredarDeBajaEnCodigoPromocional = "0";
        }
      });
    }

    if (tipoCodigoPromociones.TipoCodigoPromocionalTiposBono) {
      tipoCodigoPromociones.TipoCodigoPromocionalTiposBono.forEach((e) => {
        if (e.DeBaja === true || e.DeBaja === "1" || e.DeBaja === 1 || e.DeBaja === "true") {
          e.DeBaja = "1";
        } else {
          e.DeBaja = "0";
        }
        if (e.HeredarDeBajaEnCodigoPromocional === true || e.HeredarDeBajaEnCodigoPromocional === "1" || e.HeredarDeBajaEnCodigoPromocional === 1 || e.HeredarDeBajaEnCodigoPromocional === "true") {
          e.HeredarDeBajaEnCodigoPromocional = "1";
        } else if (e.HeredarDeBajaEnCodigoPromocional === false || e.HeredarDeBajaEnCodigoPromocional === "0" || e.HeredarDeBajaEnCodigoPromocional === 0 || e.HeredarDeBajaEnCodigoPromocional === "false") {
          e.HeredarDeBajaEnCodigoPromocional = "0";
        } else {
          e.HeredarDeBajaEnCodigoPromocional = "0";
        }
      });
    }

    tipoCodigoPromociones.CentrosIds = this.obtenercentrosAsociadosconOrden();

    if (this.editRegistroForm.controls["DeBaja"].value == true) {
      tipoCodigoPromociones.DeBaja = "1";
    } else {
      tipoCodigoPromociones.DeBaja = "0";
    }
    
    console.log('Dados antes de enviar para API:', {
      TipoCodigoPromocionalEntradas: tipoCodigoPromociones.TipoCodigoPromocionalEntradas?.map(e => ({
        pkId: e.pkId,
        TipoEntradaId: e.TipoEntradaId,
        HeredarDeBajaEnCodigoPromocional: e.HeredarDeBajaEnCodigoPromocional,
        DeBaja: e.DeBaja
      })),
      TipoCodigoPromocionalTiposBono: tipoCodigoPromociones.TipoCodigoPromocionalTiposBono?.map(e => ({
        pkId: e.pkId,
        TipoBonoId: e.TipoBonoId,
        HeredarDeBajaEnCodigoPromocional: e.HeredarDeBajaEnCodigoPromocional,
        DeBaja: e.DeBaja
      }))
    });
    
    switch (mode) {
      case "I":
        this.InsTipoCodigoPromo(tipoCodigoPromociones, cerrarpanel);
        break;
      case "U":
        //update
        this.UpdTipoCodigoPromo(tipoCodigoPromociones, cerrarpanel);

        break;
      case "D":
        //duplicate
        tipoCodigoPromociones.pkId = "0";
        this.InsTipoCodigoPromo(tipoCodigoPromociones, cerrarpanel);

        break;

      default:
        break;
    }
  }

  UpdTipoCodigoPromo(Categoria, cerrarpanel?) {
    this.editTipoCodigoPromocionesService
      .updTipoCodigoPromo(Categoria, "U")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          if (!response.DatosResult)
            this.snackvar_service.openSnackBar(
              response.Mensajes[0].DescripcionMensaje,
              "",
              "red-snackbar"
            );
          this.nextWindow(response, cerrarpanel);
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  InsTipoCodigoPromo(Categoria, cerrarpanel?) {
    this.editTipoCodigoPromocionesService
      .insTipoCodigoPromo(Categoria, "I")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          if (!cerrarpanel) {
            //this.findTipoCodigoPromocional(response.DatosResult.id);
            this.mode = "U";
            this.pkId = response.DatosResult.id;
            this.cdRef.detectChanges();
            this.ti_tiposEntrada.reloadTable();
            this.ti_tiposPromociones.reloadTable();
            //this.entryType.CentrosIds = this.obtenercentrosAsociadosconOrden()
            this.initializeTranslate();
            this.initializeFormWithoutData();
            this.manageForm(this.pkId, this.mode);
            this.columnsToDisplayTarifaEntrada = [
              "Acciones",
              "NombreTipoEntrada",
              "iNumEntradas",
            ];
            this.columnsToDisplayTarifaEntrada1 = [
              "Acciones",
              "NombreTipoEntrada",
              "iNumEntradas",
            ];
            this.cargarDatos();
          } else {
            if (!response.DatosResult)
              this.snackvar_service.openSnackBar(
                response.Mensajes[0].DescripcionMensaje,
                "",
                "red-snackbar"
              );
            this.nextWindow(response, cerrarpanel);
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }
  nextWindow(response: any, cerrarpanel?) {
    const err = this.existErrors();
    if (!this.existErrors()) {
      this.save(cerrarpanel);
      if (cerrarpanel && cerrarpanel == true) this.destroy();
      if (response.Mensajes.length > 0) {
        response.Mensajes.forEach((element) => {
          this.snackvar_service.openSnackBar(
            element.DescripcionMensaje,
            "",
            "red-snackbar",
            element.CodigoMensaje
          );
        });
      } else {
        this.snackvar_service.openSnackBar(
          this.translation["MensajeSuccessSnackBar"],
          "",
          "green-snackbar"
        );
      }
    }
  }
  existErrors() {
    return this.editRegistroForm.get("pkId").errors ||
      this.editRegistroForm.get("Nombre").errors ||
      this.editRegistroForm.get("Descripcion").errors ||
      this.editRegistroForm.get("CodigoCliente").errors ||
      this.editRegistroForm.get("CanalId").errors
      ? true
      : false;
  }
  getErrorMessage(field: string) {
    let fc_pv = this.editRegistroForm.get(field);
    if (fc_pv) {
      if (fc_pv.errors) {
        if (fc_pv.errors.required) {
          return this.translation["CampoRequerido"];
        } else if (field === "Empleado") {
          if (fc_pv.hasError("pattern")) {
            return this.translation["SoloNumeros"];
          }
        } else if (field === "Nombre") {
          if (fc_pv.hasError("pattern")) {
            return this.translation["SoloLetras"];
          }
        }
      }
    }

    return "Error";
  }

  isFieldRequired(field: string) {

    const fieldControl = this.editRegistroForm.get(field);

    if (fieldControl) {
      return fieldControl.hasError("required");
    }

    return false;
  }

  validateFields(field: string) {
    return this.isValidAnyField(field);
  }

  isValidAnyField(field: string) {
    let fc_pv = this.editRegistroForm.controls;
    return fc_pv[field].errors != null || fc_pv[field].invalid ? true : false;
  }

  /* 
  get elpkId() {
    return this.editRegistroForm.controls["pkId"].value;
  }
 */
  closeInputFilter(enventValues) {
    this.editRegistroForm.get(enventValues.name).setValue(enventValues.value);
  }

  // Métodos para añadir todas y eliminar todas

  initializeModalForm() {
    this.modalFormAnadirTodas = this.fb.group({
      CantidadLimite: ["", [
        Validators.required, 
        Validators.maxLength(5), 
        Validators.pattern(/^\d+$/),
        Validators.min(0)
      ]],
      DeBaja: [false, Validators.required]
    });
  }

  getTodasEntradasDisponibles() {
    this.editTipoCodigoPromocionesService
      .getTodasEntradasDisponibles()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data.DatosResult && data.DatosResult.Lista) {
            this.listaTodasEntradas = data.DatosResult.Lista;
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  getTodasPromocionesDisponibles() {
    // Usar diretamente getTiposBonosMs() que é a API correta (GetDatosListas tipobono0)
    // em vez de ObtenerCustomanTipoPromo que não existe
    this.servicioAPI.getTiposBonosMs()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          const raw = (data && data.DatosResult) || {};
          const list = raw.lista || [];
          if (list && list.length > 0) {
            this.listaTodasPromociones = list.map((item) => ({
              pkId: item.pkId ?? item.pkid,
              pkid: item.pkid ?? item.pkId,
              Nombre: item.Nombre ?? item.nombre ?? item.chNombre ?? "",
              nombre: item.nombre ?? item.Nombre ?? item.chNombre ?? "",
              chNombre: item.chNombre ?? item.Nombre ?? item.nombre ?? ""
            }));
          }
        },
        (error) => {
          // Silenciar erro - o fallback em anadirTodasPromociones() vai usar getTiposBonosMs() novamente
          console.warn('Erro ao carregar promoções disponíveis:', error);
        }
      );
  }

  verificarEstadoBotonesEntradas() {
    if (!this.ti_tiposEntrada || !this.ti_tiposEntrada.dataSource) {
      this.cdRef.detectChanges();
      return;
    }
    
    if (!this.listaTodasEntradas || this.listaTodasEntradas.length === 0) {
      this.cdRef.detectChanges();
      return;
    }
    
    const tieneEntradas = this.ti_tiposEntrada.dataSource.data.length > 0;
    const entradasVinculadas = tieneEntradas ? this.ti_tiposEntrada.dataSource.data.map(e => String(e.TipoEntradaId ?? e.TipoEntradaId)) : [];
    const todasLasEntradasVinculadas = this.listaTodasEntradas.every(
      entrada => entradasVinculadas.includes(String(entrada.pkId ?? entrada.pkid))
    );
    const cantidadEntradasVinculadas = entradasVinculadas.length;
    const cantidadTotalEntradas = this.listaTodasEntradas.length;
    
    // Si se eliminaron todas las entradas después de añadir todas, resetear estados
    if (this.entradasAddedAll && !tieneEntradas) {
      this.entradasAddedAll = false;
      this.entradasAddedIndividually = false;
    }
    
    // Si se eliminó una entrada después de añadir todas, rehabilitar botón "+"
    // (ya no están todas las entradas, se puede añadir individualmente)
    if (this.entradasAddedAll && tieneEntradas && !todasLasEntradasVinculadas) {
      this.entradasAddedAll = false;
      // No marcar como individualmente porque puede ser que se eliminó una
    }
    
    // Si se añadió una entrada individualmente con "+" (no todas las entradas están vinculadas)
    if (!this.entradasAddedAll && tieneEntradas && cantidadEntradasVinculadas < cantidadTotalEntradas) {
      this.entradasAddedIndividually = true;
    }
    
    // Si se añadió una entrada individualmente después de añadir todas, cambiar estado
    if (this.entradasAddedAll && tieneEntradas && !todasLasEntradasVinculadas) {
      this.entradasAddedIndividually = true;
      this.entradasAddedAll = false;
    }
    
    this.cdRef.detectChanges();
  }

  verificarEstadoBotonesPromociones() {
    if (!this.ti_tiposPromociones || !this.ti_tiposPromociones.dataSource) {
      this.cdRef.detectChanges();
      return;
    }
    
    if (!this.listaTodasPromociones || this.listaTodasPromociones.length === 0) {
      // Resetar estados se não há promoções disponíveis
      if (!this.ti_tiposPromociones.dataSource.data || this.ti_tiposPromociones.dataSource.data.length === 0) {
        this.promocionesAddedAll = false;
        this.promocionesAddedIndividually = false;
      }
      this.cdRef.detectChanges();
      return;
    }
    
    const tienePromociones = this.ti_tiposPromociones.dataSource.data.length > 0;
    const promocionesVinculadas = tienePromociones ? this.ti_tiposPromociones.dataSource.data.map(p => String(p.TipoBonoId ?? p.TipoBonoId)) : [];
    const todasLasPromocionesVinculadas = this.listaTodasPromociones.every(
      promocion => promocionesVinculadas.includes(String(promocion.pkId ?? promocion.pkid))
    );
    const cantidadPromocionesVinculadas = promocionesVinculadas.length;
    const cantidadTotalPromociones = this.listaTodasPromociones.length;
    
    // Si se eliminaron todas las promociones después de añadir todas, resetear estados
    if (this.promocionesAddedAll && !tienePromociones) {
      this.promocionesAddedAll = false;
      this.promocionesAddedIndividually = false;
    }
    
    // Si se eliminó una promoción después de añadir todas, rehabilitar botón "+"
    // (ya no están todas las promociones, se puede añadir individualmente)
    if (this.promocionesAddedAll && tienePromociones && !todasLasPromocionesVinculadas) {
      this.promocionesAddedAll = false;
      // No marcar como individualmente porque puede ser que se eliminó una
    }
    
    // Si se añadió una promoción individualmente con "+" (no todas las promociones están vinculadas)
    if (!this.promocionesAddedAll && tienePromociones && cantidadPromocionesVinculadas < cantidadTotalPromociones) {
      this.promocionesAddedIndividually = true;
    }
    
    // Si se añadió una promoción individualmente después de añadir todas, cambiar estado
    if (this.promocionesAddedAll && tienePromociones && !todasLasPromocionesVinculadas) {
      this.promocionesAddedIndividually = true;
      this.promocionesAddedAll = false;
    }
    
    this.cdRef.detectChanges();
  }

  // Métodos para habilitación de botones
  // En EDICIÓN: "Eliminar todas" se habilita solo si (1) hay al menos 1 item del otro tipo, Y (2) TODAS las filas tienen ícono basura (si alguna no tiene, el botón se desactiva).
  // En INSERCIÓN: se permite tener las dos listas vacías; el botón se habilita solo si hay items que eliminar.
  // El ícono de lixeira individual no cambia.
  isEliminarTodasEntradasDisabled(): boolean {
    const dataEntradas = this.ti_tiposEntrada?.dataSource?.data || [];
    const dataPromociones = this.ti_tiposPromociones?.dataSource?.data || [];
    if (dataEntradas.length === 0) return true;
    if (this.mode !== "I") {
      if (dataPromociones.length === 0) return true;
      const algunaSinPapelera = dataEntradas.some(
        (row) => row.hasOwnProperty("showDeleteBtn") && row.showDeleteBtn === false
      );
      if (algunaSinPapelera) return true;
    }
    return false;
  }

  isAnadirTodasEntradasDisabled(): boolean {
    const dataEntradas = this.ti_tiposEntrada?.dataSource?.data || [];
    // Si no hay ninguna entrada, siempre se permite "Añadir todas"
    if (dataEntradas.length === 0) {
      return false;
    }

    if (this.mode === "I") {
      // En inserción: deshabilitado si se añadió individualmente o todas
      return this.entradasAddedIndividually || this.entradasAddedAll;
    } else {
      // En edición: si hay cualquier entrada vinculada, no se puede "Añadir todas" de nuevo
      return true;
    }
  }

  // En EDICIÓN: "Eliminar todas" Promociones habilitado solo si hay al menos 1 entrada (del otro tipo) Y TODAS las promociones tienen ícono basura (si alguna no tiene, se desactiva).
  isEliminarTodasPromocionesDisabled(): boolean {
    const dataEntradas = this.ti_tiposEntrada?.dataSource?.data || [];
    const dataPromociones = this.ti_tiposPromociones?.dataSource?.data || [];
    if (dataPromociones.length === 0) return true;
    if (this.mode !== "I") {
      if (dataEntradas.length === 0) return true;
      const algunaSinPapelera = dataPromociones.some(
        (row) => row.hasOwnProperty("showDeleteBtn") && row.showDeleteBtn === false
      );
      if (algunaSinPapelera) return true;
    }
    return false;
  }

  isAnadirTodasPromocionesDisabled(): boolean {
    const dataPromociones = this.ti_tiposPromociones?.dataSource?.data || [];
    // Si no hay ninguna promoción, siempre se permite "Añadir todas"
    if (dataPromociones.length === 0) {
      return false;
    }

    if (this.mode === "I") {
      // En inserción: deshabilitado si se añadió individualmente o todas
      return this.promocionesAddedIndividually || this.promocionesAddedAll;
    } else {
      // En edición: si hay cualquier promoción vinculada, no se puede "Añadir todas" de nuevo
      return true;
    }
  }

  // Métodos para controlar el botón "+"
  isInsertButtonEntradasDisabled(): boolean {
    // El botón "+" está deshabilitado cuando se añadieron todas las entradas con "Añadir todas"
    return this.entradasAddedAll;
  }

  isInsertButtonPromocionesDisabled(): boolean {
    // El botón "+" está deshabilitado cuando se añadieron todas las promociones con "Añadir todas"
    return this.promocionesAddedAll;
  }

  // Métodos llamados cuando se añade una fila con el botón "+"
  onFilaAnadidaEntradas() {
    // Si se añade una entrada con "+", marcar como añadida individualmente
    // Esto deshabilitará el botón "Añadir todas"
    if (!this.entradasAddedAll) {
      this.entradasAddedIndividually = true;
      this.verificarEstadoBotonesEntradas();
    }
  }

  onFilaAnadidaPromociones() {
    // Si se añade una promoción con "+", marcar como añadida individualmente
    // Esto deshabilitará el botón "Añadir todas"
    if (!this.promocionesAddedAll) {
      this.promocionesAddedIndividually = true;
      this.verificarEstadoBotonesPromociones();
    }
  }

  abrirModalAnadirTodasEntradas() {
    this.modalFormAnadirTodas.reset({
      CantidadLimite: "",
      DeBaja: false
    });

    const dialogRef = this.dialog.open(ModalAnadirTodasComponent, {
      width: "400px",
      data: {
        titulo: this.translation.InsertarTodasLasEntradas || "Insertar todas las entradas",
        form: this.modalFormAnadirTodas,
        translation: this.translation
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirmado) {
        const cantidadLimite = result.cantidadLimite;
        const deBaja = result.deBaja;
        this.anadirTodasEntradas(cantidadLimite, deBaja);
      }
    });
  }

  abrirModalAnadirTodasPromociones() {
    this.modalFormAnadirTodas.reset({
      CantidadLimite: "",
      DeBaja: false
    });

    const dialogRef = this.dialog.open(ModalAnadirTodasComponent, {
      width: "400px",
      data: {
        titulo: this.translation.InsertarTodasLasPromociones || "Insertar todas las promociones",
        form: this.modalFormAnadirTodas,
        translation: this.translation
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirmado) {
        const cantidadLimite = result.cantidadLimite;
        const deBaja = result.deBaja;
        this.anadirTodasPromociones(cantidadLimite, deBaja);
      }
    });
  }

  anadirTodasEntradas(cantidadLimite: string, deBaja: boolean) {
    if (!this.ti_tiposEntrada || !this.ti_tiposEntrada.dataSource) return;
    if (!this.listaTodasEntradas || this.listaTodasEntradas.length === 0) return;

    const entradasVinculadas = (this.ti_tiposEntrada.dataSource.data || []).map(e => e.TipoEntradaId);
    const entradasDisponibles = this.listaTodasEntradas.filter(
      entrada => !entradasVinculadas.includes(String(entrada.pkId ?? entrada.pkid))
    );

    const nuevasFilas = entradasDisponibles.map((entrada) => ({
      pkId: "",
      TipoEntradaId: String(entrada.pkId ?? entrada.pkid),
      NombreTipoEntrada: entrada.Nombre ?? entrada.nombre ?? entrada.chNombre ?? "",
      CantidadLimite: cantidadLimite,
      DeBaja: deBaja,
      HeredarDeBajaEnCodigoPromocional: false
    }));

    const data = this.ti_tiposEntrada.dataSource.data || [];
    this.ti_tiposEntrada.dataSource.data = [...data, ...nuevasFilas];
    this.ti_tiposEntrada.dataSource.filter = "";
    this.entradasAddedAll = true;
    this.entradasAddedIndividually = false;
    this.verificarEstadoBotonesEntradas();
    
    // Adicionar verificação de Promociones após mudanças em Entradas
    // Usar setTimeout para garantir que o DOM seja atualizado antes da verificação
    setTimeout(() => {
      this.verificarEstadoBotonesPromociones();
      this.cdRef.detectChanges();
    }, 100);
    
    this.cdRef.detectChanges();
  }

  anadirTodasPromociones(cantidadLimite: string, deBaja: boolean) {
    if (!this.ti_tiposPromociones || !this.ti_tiposPromociones.dataSource) return;

    // Se a lista de promoções estiver vazia (ex.: API ObtenerCustomanTipoPromo diferente),
    // usar a mesma fonte que a tabela: GetDatosListas tipobono0
    if (!this.listaTodasPromociones || this.listaTodasPromociones.length === 0) {
      this.servicioAPI.getTiposBonosMs()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            const raw = (data && data.DatosResult) || {};
            const list = raw.lista || [];
            if (list.length > 0) {
              this.listaTodasPromociones = list.map((item) => ({
                pkId: item.pkId ?? item.pkid,
                pkid: item.pkid ?? item.pkId,
                Nombre: item.Nombre ?? item.nombre ?? "",
                nombre: item.nombre ?? item.Nombre ?? "",
                chNombre: item.chNombre ?? item.Nombre ?? item.nombre ?? ""
              }));
            }
            this.anadirTodasPromociones(cantidadLimite, deBaja);
          },
          () => this.cdRef.detectChanges()
        );
      return;
    }

    const id = (p) => p.pkId ?? p.pkid;
    const nombre = (p) => p.Nombre ?? p.nombre ?? p.chNombre ?? "";
    const promocionesVinculadas = (this.ti_tiposPromociones.dataSource.data || []).map(p => p.TipoBonoId);
    const promocionesDisponibles = this.listaTodasPromociones.filter(
      promocion => !promocionesVinculadas.includes(String(id(promocion)))
    );

    const nuevasFilas = promocionesDisponibles.map((promocion) => ({
      pkId: "",
      TipoBonoId: String(id(promocion)),
      NombreTipoEntrada: nombre(promocion),
      CantidadLimite: cantidadLimite,
      DeBaja: deBaja,
      HeredarDeBajaEnCodigoPromocional: false,
      BaseImponible: "0",
      showDeleteBtn: true
    }));

    const data = this.ti_tiposPromociones.dataSource.data || [];
    this.ti_tiposPromociones.dataSource.data = [...data, ...nuevasFilas];
    this.ti_tiposPromociones.dataSource.filter = "";

    this.promocionesAddedAll = true;
    this.promocionesAddedIndividually = false;
    this.verificarEstadoBotonesPromociones();
    this.cdRef.detectChanges();
  }

  eliminarTodasEntradas() {
    const dialogRef = this.dialog.open(DialogoPopUp, {
      width: "400px",
      data: {
        titulo: this.translation.EliminarTodasLasEntradas || "Eliminar todas las entradas",
        texto: this.translation.EstaSeguroQueDeseaEliminarTodasLasEntradas || "¿Está seguro que desea eliminar todas las entradas?",
        eleccion: "",
        ok: this.translation.Confirmar || "Confirmar",
        ko: this.translation.Cancelar || "Cancelar",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "SI") {
        if (this.mode === "U") {
          // Edición: llamar al servicio ActualizarCustomanTipoCodigoPromocional con lista de entradas vacía
          // Usar copia de cada fila para no mutar los datos de la tabla Promociones (evitar que se activen los checks)
          const promocionesCopy = (this.ti_tiposPromociones?.dataSource?.data || []).map((row) => ({ ...row }));
          const payload: tipoCodigoPromociones = {
            ...this.editRegistroForm.value,
            TipoCodigoPromocionalEntradas: [],
            TipoCodigoPromocionalTiposBono: promocionesCopy,
          };
          this.normalizePayloadForUpdate(payload);
          this.loading = true;
          this.editTipoCodigoPromocionesService
            .updTipoCodigoPromo(payload, "U")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (response) => {
                this.loading = false;
                if (response.DatosResult) {
                  if (this.ti_tiposEntrada?.dataSource) {
                    this.ti_tiposEntrada.dataSource.data = [];
                    this.ti_tiposEntrada.dataSource.filter = "";
                  }
                  this.entradasAddedAll = false;
                  this.entradasAddedIndividually = false;
                  this.verificarEstadoBotonesEntradas();
                  this.verificarEstadoBotonesPromociones();
                  this.manageForm(this.pkId, this.mode);
                } else if (response.Mensajes?.length) {
                  this.snackvar_service.openSnackBar(
                    response.Mensajes[0].DescripcionMensaje,
                    "",
                    "red-snackbar"
                  );
                }
                this.cdRef.detectChanges();
              },
              (error) => {
                this.loading = false;
                this.httpErrorService.identificarErrores(error);
                this.cdRef.detectChanges();
              }
            );
        } else {
          // Inserción: solo eliminación visual; rehabilitar "+" y "Agregar todas"
          if (this.ti_tiposEntrada && this.ti_tiposEntrada.dataSource) {
            this.ti_tiposEntrada.dataSource.data = [];
            this.ti_tiposEntrada.dataSource.filter = "";
            this.entradasAddedAll = false;
            this.entradasAddedIndividually = false;
            this.verificarEstadoBotonesEntradas();
            this.verificarEstadoBotonesPromociones();
            this.cdRef.detectChanges();
          }
        }
      }
    });
  }

  eliminarTodasPromociones() {
    const dialogRef = this.dialog.open(DialogoPopUp, {
      width: "400px",
      data: {
        titulo: this.translation.EliminarTodasLasPromociones || "Eliminar todas las promociones",
        texto: this.translation.EstaSeguroQueDeseaEliminarTodasLasPromociones || "¿Está seguro que desea eliminar todas las promociones?",
        eleccion: "",
        ok: this.translation.Confirmar || "Confirmar",
        ko: this.translation.Cancelar || "Cancelar",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "SI") {
        if (this.mode === "U") {
          // Edición: llamar al servicio ActualizarCustomanTipoCodigoPromocional con lista de promociones vacía
          // Usar copia de cada fila para no mutar los datos de la tabla Entradas (evitar que se activen los checks)
          const entradasCopy = (this.ti_tiposEntrada?.dataSource?.data || []).map((row) => ({ ...row }));
          const payload: tipoCodigoPromociones = {
            ...this.editRegistroForm.value,
            TipoCodigoPromocionalEntradas: entradasCopy,
            TipoCodigoPromocionalTiposBono: [],
          };
          this.normalizePayloadForUpdate(payload);
          this.loading = true;
          this.editTipoCodigoPromocionesService
            .updTipoCodigoPromo(payload, "U")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (response) => {
                this.loading = false;
                if (response.DatosResult) {
                  if (this.ti_tiposPromociones?.dataSource) {
                    this.ti_tiposPromociones.dataSource.data = [];
                    this.ti_tiposPromociones.dataSource.filter = "";
                  }
                  this.promocionesAddedAll = false;
                  this.promocionesAddedIndividually = false;
                  this.verificarEstadoBotonesEntradas();
                  this.verificarEstadoBotonesPromociones();
                  this.manageForm(this.pkId, this.mode);
                } else if (response.Mensajes?.length) {
                  this.snackvar_service.openSnackBar(
                    response.Mensajes[0].DescripcionMensaje,
                    "",
                    "red-snackbar"
                  );
                }
                this.cdRef.detectChanges();
              },
              (error) => {
                this.loading = false;
                this.httpErrorService.identificarErrores(error);
                this.cdRef.detectChanges();
              }
            );
        } else {
          // Inserción: solo eliminación visual; rehabilitar "+" y "Agregar todas"
          if (this.ti_tiposPromociones && this.ti_tiposPromociones.dataSource) {
            this.ti_tiposPromociones.dataSource.data = [];
            this.ti_tiposPromociones.dataSource.filter = "";
            this.promocionesAddedAll = false;
            this.promocionesAddedIndividually = false;
            this.verificarEstadoBotonesEntradas();
            this.verificarEstadoBotonesPromociones();
            this.cdRef.detectChanges();
          }
        }
      }
    });
  }

  /**
   * Normaliza el payload (DeBaja, HeredarDeBajaEnCodigoPromocional, CentrosIds) antes de enviar a ActualizarCustomanTipoCodigoPromocional.
   */
  private normalizePayloadForUpdate(payload: tipoCodigoPromociones): void {
    if (payload.TipoCodigoPromocionalEntradas?.length) {
      payload.TipoCodigoPromocionalEntradas.forEach((e) => {
        e.DeBaja = e.DeBaja === true || e.DeBaja === "1" || e.DeBaja === 1 || e.DeBaja === "true" ? "1" : "0";
        e.HeredarDeBajaEnCodigoPromocional =
          e.HeredarDeBajaEnCodigoPromocional === true || e.HeredarDeBajaEnCodigoPromocional === "1" || e.HeredarDeBajaEnCodigoPromocional === 1 || e.HeredarDeBajaEnCodigoPromocional === "true"
            ? "1"
            : "0";
      });
    }
    if (payload.TipoCodigoPromocionalTiposBono?.length) {
      payload.TipoCodigoPromocionalTiposBono.forEach((e) => {
        e.DeBaja = e.DeBaja === true || e.DeBaja === "1" || e.DeBaja === 1 || e.DeBaja === "true" ? "1" : "0";
        e.HeredarDeBajaEnCodigoPromocional =
          e.HeredarDeBajaEnCodigoPromocional === true || e.HeredarDeBajaEnCodigoPromocional === "1" || e.HeredarDeBajaEnCodigoPromocional === 1 || e.HeredarDeBajaEnCodigoPromocional === "true"
            ? "1"
            : "0";
      });
    }
    payload.CentrosIds = this.obtenercentrosAsociadosconOrden();
    payload.DeBaja = this.editRegistroForm.controls["DeBaja"].value === true ? "1" : "0";
  }
}
